import { CognitoUserSession } from 'amazon-cognito-identity-js';

export enum IdentityProvider {
    OTP = 'OTP',
    AMAZON_FEDERATE = 'AmazonFederate',
    LOGIN_WITH_AMAZON = 'LoginWithAmazon',
}

export interface AuthIdentity {
    dateCreated: string;
    issuer: string | null;
    primary: string;
    providerName: IdentityProvider;
    providerType: string;
    userId: string;
}

export interface DecodedToken {
    acl_email_allowed: string;
    at_hash: string;
    aud: string;
    auth_time: number;
    'cognito:username': string;
    email: string;
    email_verified: boolean;
    exp: number;
    family_name?: string;
    given_name?: string;
    hat_id: string;
    iat: number;
    identities?: AuthIdentity[];
    iss: string;
    jti: string;
    name: string;
    nonce: string;
    origin_jti: string;
    public_provider_name: IdentityProvider;
    sub: string;
    token_use: string;
    vibe_user_id: string;
}

export enum AuthError {
    NoCurrentUser = 'No current user',
    WrongProvider = 'Wrong provider',
}

interface AuthenticateOptions {
    redirect?: string;
}

export interface AuthContextValue {
    signIn: (
        identityProvider?: IdentityProvider,
        options?: AuthenticateOptions
    ) => Promise<void>;
    signOut: () => Promise<void>;
    getCurrentSession: (
        identityProvider?: IdentityProvider
    ) => Promise<CognitoUserSession | undefined>;
}
